let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iE8JQ")).then(() => parcelRequire('lysty'));